import React from 'react';
import { Button, Modal, ModalBody, ModalHeader, ModalFooter } from 'reactstrap';

const ConfirmModal = ({
  actionFunction,
  buttonText,
  bodyText,
  showModal,
  title,
  toggleFunction
}) => (
  <Modal isOpen={showModal} toggle={toggleFunction} centered>
    <ModalHeader toggle={toggleFunction}>
      Confirm: {title}
    </ModalHeader>
    <ModalBody>
      {bodyText}
    </ModalBody>
    <ModalFooter className="justify-content-end border-0">
      <Button color="link" onClick={() => toggleFunction()}>
        Cancel
      </Button>
      <Button
        className="min-width-max-content mr-3"
        color="primary"
        onClick={() => {
          toggleFunction();
          actionFunction();
        }}
      >
        {buttonText}
      </Button>
    </ModalFooter>
  </Modal>
);

export default ConfirmModal;
